import SettingsMixin from "./SettingsMixin";

// Dieses Mixin ist eine dynamische Klasse. Sie wrappt alle Funktionen des Settingsmixin
// Dabei checkt Sie aber die jeweiligen Modelle, und geht im Default auf das 'Standard'-Modell
export class ModellSettingsMixin {}
 
for(const key of Object.getOwnPropertyNames(SettingsMixin.prototype)) {
    const settingsMethod = SettingsMixin.prototype[key];
    ModellSettingsMixin.prototype[key] = function(modell, key, ...args) {
        if(this[modell]) {
            if(this[modell][key]) {
                return settingsMethod.call(this[modell], key, ...args);
            } else if(this['Standard'][key]) {
                return settingsMethod.call(this['Standard'],key, ...args);
            } else {
                console.warn("You are asking for a Setting which is nonexistent in your model and Fallback!", key, modell);
                return '';
            }
        } else {
            console.warn("Asking Setting for non existing modell:", modell);
            return '';
        }
    }
}